import React from 'react'

const LinkIcon = () => {
    return (
        <svg
            // width="21" height="20" 
            style={{ height: '50%' }}
            viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.6748 15.3215L16.3592 4.84204M16.3592 4.84204V14.9023M16.3592 4.84204H6.10218" stroke="white" stroke-width="1.23282" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default LinkIcon